import { TeaserClient } from "./TeaserClient";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import { onLoad } from "@otto-ec/global-resources/dom";
import { Teaser } from "./teaser";

const teaserClient = new TeaserClient();

onLoad.on(() => {
	new Teaser(teaserClient, eventQBus).init();
});
